/* ==========================================================================
   CL - PDP Rediseno - comportamiento
   ESTRATEGIA: componentes PROPIOS en vez de forzar los del tema (mover o
   re-cablear sus bloques rompia "Ir a pagar" y destapaba spinners):
   - Precio bajo el titulo (mobile): espejo propio sincronizado con el
     precio del tema (se actualiza al cambiar variante); nada se mueve.
   - Sticky de compra propio (.cl-pdp-stick, lo pinta la seccion): titulo
     truncado, precio sincronizado, stepper propio y Agregar al carrito
     via /cart/add.js con la variante seleccionada del form del tema.
     El sticky del tema queda apagado por CSS.
   - Descripcion como dropdown (acordeon propio con el look del tema).
   - Flechas de acordeones (.cl-open) y boton "subir".
   ========================================================================== */

(function () {
	'use strict';

	var MOBILE = window.matchMedia('(max-width: 749px)');

	function getRoot() {
		return document.querySelector('.shopify-section[id*="main-product"]') || document;
	}

	/* ---------- panel de compra arriba de los dropdowns (solo mobile) ----------
	   El tema parte los bloques en DOS columnas y la buy box vive en la
	   segunda: en mobile siempre caia al final aunque en el editor este
	   arriba. Se mueve el nodo completo (listeners intactos) despues de
	   las variantes. El precio NO se toca (de eso se encarga el espejo). */
	function moveBuyBox(root) {
		if (!MOBILE.matches) return;
		var col1 = root.querySelector('.product__info-container--col');
		var buyWrap = root.querySelector('.buy-box__wrapper');
		if (!col1 || !buyWrap) return;
		/* Ancla: el bloque de variantes. Un producto SIN variantes no lo trae
		   (el tema no pinta .product-parameters), y antes la buy box se quedaba
		   al final, debajo de los dropdowns: entonces va justo despues del
		   precio espejo / titulo (lo que exista). */
		var ancla =
			col1.querySelector('.product-parameters') ||
			col1.querySelector('.cl-pdp-price') ||
			col1.querySelector('.product__title__wrapper');
		if (ancla) ancla.insertAdjacentElement('afterend', buyWrap);
	}

	/* ---------- precio espejo bajo el titulo (solo mobile) ---------- */
	function initPriceMirror(root) {
		if (!MOBILE.matches) return;
		var col1 = root.querySelector('.product__info-container--col');
		var titleWrap = col1 ? col1.querySelector('.product__title__wrapper') : null;
		var srcWrap = root.querySelector('.buy-box .buy-box-price-wrapper');
		if (!titleWrap || !srcWrap || root.querySelector('.cl-pdp-price')) return;

		var mirror = document.createElement('div');
		mirror.className = 'cl-pdp-price';
		titleWrap.insertAdjacentElement('afterend', mirror);

		var sync = function () {
			var price = srcWrap.querySelector('.price');
			var badge = srcWrap.querySelector('.discount-badge');
			mirror.innerHTML = '';
			if (price) mirror.appendChild(price.cloneNode(true));
			if (badge) mirror.appendChild(badge.cloneNode(true));
		};
		sync();
		new MutationObserver(sync).observe(srcWrap, { childList: true, subtree: true, characterData: true });
	}

	/* ---------- sticky de compra propio ---------- */
	function initStick(root) {
		var stick = document.querySelector('[data-cl-pdp-stick]');
		if (!stick) return;
		stick.hidden = false;

		/* precio sincronizado con el del tema (cambia con la variante) */
		var priceOut = stick.querySelector('[data-stick-price]');
		var srcWrap = root.querySelector('.buy-box .buy-box-price-wrapper');
		if (priceOut && srcWrap) {
			var syncPrice = function () {
				var item = srcWrap.querySelector('.price__sale .price-item--sale, .price-item--sale, .price-item');
				if (item) priceOut.textContent = item.textContent.trim();
			};
			syncPrice();
			new MutationObserver(syncPrice).observe(srcWrap, { childList: true, subtree: true, characterData: true });
		}

		/* stepper propio */
		var qtyOut = stick.querySelector('[data-stick-qty]');
		var qty = 1;
		stick.querySelector('[data-stick-minus]').addEventListener('click', function () {
			qty = Math.max(1, qty - 1);
			qtyOut.textContent = qty;
		});
		stick.querySelector('[data-stick-plus]').addEventListener('click', function () {
			qty = Math.min(99, qty + 1);
			qtyOut.textContent = qty;
		});

		/* agregar al carrito con la variante seleccionada en el form del tema */
		var atc = stick.querySelector('[data-stick-atc]');
		atc.addEventListener('click', function () {
			var idInput = root.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] [name="id"]');
			var variantId = idInput ? parseInt(idInput.value, 10) : null;
			if (!variantId) return;
			atc.disabled = true;
			fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ id: variantId, quantity: qty })
			})
				.then(function (r) { return r.json(); })
				.then(function () {
					atc.disabled = false;
					/* refrescar y abrir el cart-drawer del tema */
					var drawerEl = document.querySelector('cart-drawer');
					fetch('/?sections=cart-drawer')
						.then(function (r) { return r.json(); })
						.then(function (data) {
							if (data['cart-drawer'] && drawerEl) {
								var tmp = document.createElement('div');
								tmp.innerHTML = data['cart-drawer'];
								var inner = tmp.querySelector('cart-drawer');
								if (inner) drawerEl.innerHTML = inner.innerHTML;
							}
							if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open(atc);
						})
						.catch(function () {
							if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open(atc);
						});
				})
				.catch(function () { atc.disabled = false; });
		});

		/* aparece cuando el bloque de compra del tema sale por ARRIBA */
		var buyBtns = root.querySelector('.buy-box .product-form__buttons') || root.querySelector('.product-form__buttons');
		if (buyBtns && 'IntersectionObserver' in window) {
			new IntersectionObserver(
				function (entries) {
					var fuera = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
					stick.classList.toggle('is-show', fuera);
				},
				{ threshold: 0 }
			).observe(buyBtns);
		}
	}

	/* ---------- Descripcion como dropdown ---------- */
	function buildDescAccordion(root) {
		var desc = root.querySelector('.main-product__long-desc');
		if (!desc || root.querySelector('.cl-pdp-desc-acc')) return;

		/* arranca CERRADO (sin .cl-open); el toque la abre */
		var acc = document.createElement('div');
		acc.className = 'product-accordion cl-pdp-desc-acc';
		acc.innerHTML =
			'<button type="button" class="button button--simple product-accordion__toggle cl-pdp-desc-toggle">' +
			'<div class="button__content">' +
			'<span class="button__label">Descripci\u00f3n</span>' +
			'<div class="product-accordion__icon"></div>' +
			'</div>' +
			'</button>' +
			'<div class="product-accordion__content"></div>';

		var col1 = root.querySelector('.product__info-container--col');
		var accs = col1 ? col1.querySelectorAll('.product-accordion') : [];
		var ancla = accs.length ? accs[accs.length - 1] : col1 ? col1.lastElementChild : null;
		if (!ancla) return;
		ancla.insertAdjacentElement('afterend', acc);
		acc.querySelector('.product-accordion__content').appendChild(desc);

		acc.querySelector('.cl-pdp-desc-toggle').addEventListener('click', function () {
			acc.classList.toggle('cl-open');
		});
	}

	/* ---------- flechas de los acordeones del tema ---------- */
	function trackAccordions(root) {
		root.querySelectorAll('.product-accordion__toggle:not(.cl-pdp-desc-toggle)').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var acc = btn.closest('.product-accordion');
				if (acc) acc.classList.toggle('cl-open');
			});
		});
	}

	/* ---------- boton "subir" ---------- */
	function initTopBtn() {
		var loader = document.querySelector('[data-cl-pdp]');
		var quiere = !loader || loader.dataset.topBtn !== 'false';
		if (!quiere || document.querySelector('.cl-pdp-top')) return;

		var btn = document.createElement('button');
		btn.type = 'button';
		btn.className = 'cl-pdp-top';
		btn.setAttribute('aria-label', 'Volver arriba');
		btn.innerHTML =
			'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
		document.body.appendChild(btn);

		btn.addEventListener('click', function () {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});

		var shown = false;
		var onScroll = function () {
			var should = window.scrollY > 600;
			if (should !== shown) {
				shown = should;
				btn.classList.toggle('is-show', shown);
			}
		};
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	}

	function init() {
		var root = getRoot();
		/* primero el precio espejo (queda bajo el titulo) y luego la buy
		   box, que se ancla a lo ultimo que exista */
		initPriceMirror(root);
		moveBuyBox(root);
		initStick(root);
		buildDescAccordion(root);
		trackAccordions(root);
		initTopBtn();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	/* Al volver a la PDP con el boton atras (bfcache): el script del boton
	   "Ir a pagar" del tema (#buy-it-now-btn) deja label.style.opacity=0,
	   el spinner visible y el boton deshabilitado antes de redirigir al
	   checkout, y NUNCA lo restaura en exito - se restaura aqui. */
	window.addEventListener('pageshow', function (event) {
		if (!event.persisted) return;
		document.querySelectorAll('.product-form__submit').forEach(function (btn) {
			/* agotado: el tema solo pone data-button-text cuando hay stock */
			if (!btn.hasAttribute('data-button-text') || btn.classList.contains('disabled')) return;
			btn.classList.remove('loading');
			btn.removeAttribute('aria-busy');
			btn.removeAttribute('aria-disabled');
			btn.disabled = false;
			var label = btn.querySelector('.button__label');
			if (label) label.style.opacity = '';
			var spinner = btn.querySelector('.loading-overlay__spinner');
			if (spinner) spinner.classList.add('hidden');
		});
	});
})();
